import { render, staticRenderFns } from "./EditPartner.vue?vue&type=template&id=4b5e529a&scoped=true&"
import script from "./EditPartner.vue?vue&type=script&lang=js&"
export * from "./EditPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5e529a",
  null
  
)

export default component.exports